<div class="content">
    Nie nadałeś uprawnień dla kamery
    <br />check your setings and then <br /><strong>Add to homescreen</strong>.
    <div class="full-width"><mat-icon>arrow_downward</mat-icon></div>
</div>
<button class="btn-close" mat-icon-button (click)="close()" aria-label="Close">
    <mat-icon>close</mat-icon>
</button>